import { render, staticRenderFns } from "./ObjectBurials.vue?vue&type=template&id=22aa6548&"
import script from "./ObjectBurials.vue?vue&type=script&lang=js&"
export * from "./ObjectBurials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports